import MainNotifications from "../components/notifications/MainNotifications";

function Notifications() {
  return (
    <div>
      <MainNotifications />
    </div>
  );
}

export default Notifications;
